import { useNumberFormatter } from 'common/hooks';
import { useMemo } from 'react';
import type { ProductPriceToDisplayProps } from './types';

export const useProductPrice = ({
  price,
  productPriceCategory,
  hasOldPrice,
}: ProductPriceToDisplayProps) => {
  const formatter = useNumberFormatter({
    options: { currency: price.currency, currencyDisplay: 'symbol', style: 'currency' },
  });

  const formattedPrice = useMemo(() => formatter.format(price.main_price), [formatter, price.main_price]);
  const formattedOldPrice = useMemo(
    () => formatter.format(price.previous_price || 0),
    [formatter, price.previous_price]
  );

  const [rawPrice, finalCurrency] = useMemo(() => {
    const indexOfCurrency = formattedPrice.indexOf('₽');
    return [formattedPrice.slice(0, indexOfCurrency), formattedPrice.slice(indexOfCurrency)];
  }, [formattedPrice]);

  const { finalPriceFirst, finalPriceSecond } = useMemo(() => {
    const pricesArr = rawPrice.split(',');
    const hasComma = Boolean(parseInt(pricesArr[1], 10));
    const mainPrice = pricesArr[0];
    const fractPrice = hasComma ? pricesArr[1] : null;
    return { finalPriceFirst: mainPrice, finalPriceSecond: fractPrice };
  }, [rawPrice]);

  const hasBestPrice = productPriceCategory === 'BPR';
  const hasSpecialPrice = hasOldPrice || hasBestPrice;

  return {
    formattedOldPrice,
    finalCurrency,
    finalPriceFirst,
    finalPriceSecond,
    hasSpecialPrice,
    hasBestPrice,
  };
};
